import { z } from "zod";
import { COMPANY_STATUSES, COMPANY_TIERS } from "../constants.js";
export const createCompanySchema = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
    tier: z.enum(COMPANY_TIERS).optional(),
    issuePrefix: z.string().min(2).max(6).toUpperCase().optional(),
    brandColor: z.preprocess((val) => (typeof val === "string" && val.trim() === "" ? undefined : val), z.string().regex(/^#[0-9a-fA-F]{6}$/).optional()),
});
export const updateCompanySchema = z.object({
    name: z.string().min(1).max(100).optional(),
    description: z.string().max(500).nullable().optional(),
    status: z.enum(COMPANY_STATUSES).optional(),
    tier: z.enum(COMPANY_TIERS).optional(),
    budgetMonthlyCents: z.number().int().min(0).optional(),
    brandColor: z.string().regex(/^#[0-9a-fA-F]{6}$/).nullable().optional(),
    logoUrl: z.string().max(200000).nullable().optional(),
});
//# sourceMappingURL=company.js.map